module.exports = __webpack_public_path__ + "static/media/house_12.2b40c0d4.jpg";